import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import CareimageModel from "@/commons/models/Careimage";
import CareimageStatusModel from "@/commons/models/CareimageStatus";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 介護記録 API 操作クラス
 */
export default class CareimageStatuses {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET CareimageStatuses
   */
  public async get(userStore: LoginUser, queryParams: { start: number; end: number }): Promise<Map<number, CareimageStatusModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.CareimageStatuses, formatParams);
    const response = await this.commonService.executeGet<Array<CareimageStatusModel>>(userStore, requestUrl, this.constructor.name, queryParams, HitomeqErrorType.REQUEST_RETRY, 0);
    const result: Map<number, CareimageStatusModel> = this.createGetResponse(response.data);

    return result;
  }

  /**
   * GETの返却用Model作成
   *
   * @param body レスポンスボディ
   */
  private createGetResponse(body: Array<CareimageStatusModel>): Map<number, CareimageStatusModel> {
    // 介護記録状態をMap化する
    const response = new Map<number, CareimageStatusModel>();
    for (const status of body) {
      response.set(status.datetime, status);
    }

    return response;
  }

  /**
   * PATCH CareimageStatuses
   */
  public async patch(userStore: LoginUser, careimageDate: number, careimage: CareimageModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      careimageDate: careimageDate
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.CareimageStatusesDatetime, formatParams);

    // APIのモデルに合わせてここで送信内容を調整
    const requestBody: any = {
      isPublic: careimage.isPublic,
      writtenBy: careimage.writtenBy,
      writerId: careimage.writerId
    };

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
